export default "__VITE_ASSET__D5Oa1nU0__"